// extracted by mini-css-extract-plugin
export var wrapper = "events-module--wrapper--3A6Nn";
export var heading = "events-module--heading--dQsgs";
export var events = "events-module--events--vgvJX";
export var events__list = "events-module--events__list--18XSk";